<template>
  <div id="sidebar">

    <div id="sidebarContent">

      <div class="box">

        <div class="boxTitle">
          <h2>Novinky</h2>
        </div>

        <div class="boxContent">

          <!--<div class="article">-->
            <!--<h3><router-link to="/voucher">Dárkové poukazy</router-link></h3>-->
            <!--<ins>02.12.2012</ins>-->
            <!--<div class="articleContent">Od prosince můžete pro své psí miláčky zakoupit <router-link to="/voucher">dárkové poukazy</router-link> na služby Salonu Jája.</div>-->
          <!--</div>-->

          <!--<div class="article">-->
            <!--<h3><router-link to="/massage">Masáže psů</router-link></h3>-->
            <!--<ins>25.11.2012</ins>-->
            <!--<div class="articleContent">Salon Jája nově nabízí <router-link to="/massage">masáže psů</router-link>.</div>-->
          <!--</div>-->

          <p class="notFound">V této rubrice nejsou žádné články.</p>

        </div>

      </div>

      <div class="cleaner">
        <!-- / -->
      </div>

      <div class="box">

        <div class="boxTitle">
          <h2>Kontakt</h2>
        </div>

        <div class="boxContent">

          <div id="contact">

            <p class="name">Lenka Holubová</p>

            <p class="address">
              Pražského 662 (vchod z boku domu)<br />
              Praha 5 - Hlubočepy (Barrandov)
            </p>

            <p class="phone">+420 723 222 400</p>

            <p class="email">
              <a href="mailto:holubova@salonjaja.cz">
                <span id="rbcContactEmail">holubova@salonjaja.cz</span>
              </a>
            </p>

          </div>

        </div>

      </div>


      <div class="cleaner">
        <!-- / -->
      </div>

      <div class="box">

        <div class="boxTitle">
          <h2>Certifikáty</h2>
        </div>

        <div class="boxContent">
          <div class="certificates">
            <a :href="require('../../../static/photos/certificates/clippers.jpg')" class="fancybox" rel="certificates" title="Certifikát střihové úpravy pudla"><img src="../../../static/photos/certificates/thumb_clippers.jpg" width="240"/></a>
            <a :href="require('../../../static/photos/certificates/massage.jpg')" class="fancybox" rel="certificates" title="Certifikát masáže psů"><img src="../../../static/photos/certificates/thumb_massage.jpg" width="240"/></a>
          </div>
        </div>

      </div>

      <div class="cleaner">
        <!-- / -->
      </div>

    </div>

  </div>
</template>

<script>
  import fancybox from './../../assets/js/fancybox'

  export default {
    name: 'app-sidebar',
    mounted () {
      fancybox('#sidebar .fancybox')
    }
  }
</script>



// WEBPACK FOOTER //
// AppSidebar.vue?2efd35c3